import { render, staticRenderFns } from "./modalAdicionarItens.vue?vue&type=template&id=13c5f53e&scoped=true&"
import script from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
export * from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
import style0 from "./modalAdicionarItens.vue?vue&type=style&index=0&id=13c5f53e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5f53e",
  null
  
)

export default component.exports